import { observer } from 'mobx-react-lite';
import { GlobalLoaderStore } from './global-loader.store';

import './global-loader.scss';

const GlobalLoaderView = ({ loaderStore }: { loaderStore: GlobalLoaderStore }) => {
   if (!loaderStore.visible) {
      return null;
   }
   return (
      <div className="loader-overlay">
         <div className="loadingio-spinner-spinner-6i46094v87">
            <div className="ldio-1gihoq8uha">
               <div></div>
               <div></div>
               <div></div>
               <div></div>
               <div></div>
               <div></div>
               <div></div>
               <div></div>
               <div></div>
               <div></div>
               <div></div>
               <div></div>
               <div></div>
               <div></div>
               <div></div>
               <div></div>
               <div></div>
            </div>
         </div>
      </div>
   );
};

export const GlobalLoader = observer(GlobalLoaderView);
